module.exports = __webpack_public_path__ + "fonts/AvenirSemiBold.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/AvenirSemiBold.woff2
// module id = 477
// module chunks = 12